import React from "react";
import { RxExternalLink } from "react-icons/rx";
import { Link } from "react-router-dom";
import { sortDateTime } from "../../../utils/utils";
import CustomChips from "../../../../reusableComponents/CustomChips";
import { colorBrandObject } from "../../../../../constants/brandings";

export const notificationSchema = {
  metadata: {
    title: "Webhooks",
    minHeight: 600,
    position: "relative",
    showTitle: false,
    rowHeight: 60,
  },
  fields: [
    {
      name: "notificationId",
      header: "Notification ID",
      visible: true,
      type: "string",
      filtering: false,
      minWidth: 150,
      defaultWidth: 200,
      defaultFlex: 1,
      textAlign: "center",
      render: ({ data }) => {
        const notifyId = data.notificationId;
        return (
          <span style={{ display: "flex", marginLeft: "-12px" }}>
            {notifyId}
            <Link
              to={
                "/developers/webhooks/notifications_Details?notifyId=" +
                notifyId
              }
            >
              <RxExternalLink
                style={{
                  width: "24px",
                  height: "16px",
                  cursor: "pointer",
                  position: "absolute",
                  right: "0",
                  marginRight: "16px",
                  color:`${colorBrandObject?.actionIconColor}`
                }}
              />
            </Link>
          </span>
        );
      },
    },
    {
      name: "eventId",
      header: "Event ID",
      visible: true,
      type: "string",
      defaultFlex: 1,
      filtering: false,
      defaultWidth: 200,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "operationId",
      header: "Operation ID",
      visible: true,
      type: "string",
      filtering: false,
      defaultFlex: 1,
      textAlign: "center",
      defaultWidth: 200,
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "orderId",
      header: "Order ID",
      visible: true,
      type: "string",
      defaultFlex: 1,
      filtering: false,
      defaultWidth: 200,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "transactionId",
      header: "Transaction ID",
      visible: false,
      type: "string",
      defaultFlex: 1,
      filtering: false,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "legalEntityCode",
      header: "Legal Entity",
      visible: false,
      type: "string",
      filtering: false,
      defaultFlex: 1,
      defaultWidth: 200,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "clientPosId",
      header: "Store ID",
      visible: false,
      type: "string",
      defaultFlex: 1,
      filtering: false,
      defaultWidth: 230,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "notificationResponseStatusCode",
      header: "Response Code",
      visible: true,
      type: "number",
      filtering: false,
      defaultFlex: 1,
      defaultWidth: 170,
      textAlign: "center",
      render: ({ value }) => {
        let backgroundColor;
        let color;

        if (value.toString()[0] === "2") {
          backgroundColor = "var(--comms-positive-sub, #D5FBD2)";
          color = "var(--comms-positive, #0B6A48)";
        } else {
          backgroundColor = "var(--comms-negative-sub, #FDE3D6)";
          color = "var(--comms-negative, #B9232F)";
        }
        return (
          <span
            style={{
              marginLeft: "-10px",
              paddingBottom: "5px",
              paddingRight: "16px",
              paddingLeft: "16px",
              paddingTop: "5px",
              borderRadius: "8px",
              backgroundColor,
              color,
              fontFamily: "Poppins",
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      name: "notificationResponse",
      header: "Response",
      visible: false,
      type: "string",
      filtering: false,
      defaultWidth: 150,
      defaultFlex: 1,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
    {
      name: "timestamp",
      header: "Time Stamp",
      visible: true,
      type: "string",
      defaultFlex: 1,
      filtering: false,
      defaultWidth: 300,
      textAlign: "center",
      width:"400",
      sort: sortDateTime,
      render: ({data}) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{data?.timestamp}</span>
      ),
    },
    {
      name: "timeTakenInMs",
      header: "Time Taken (in ms)",
      visible: false,
      type: "string",
      filtering: false,
      defaultWidth: 230,
      defaultFlex: 1,
      textAlign: "center",
      render: ({ value }) => (
        <span style={{ display: "flex", marginLeft: "-12px" }}>{value}</span>
      ),
    },
  ],
};
